import { createStyles, makeStyles } from "@material-ui/core/styles";


export default makeStyles((theme) => createStyles({
    content: {
        padding: "30px 60px",
        height: "calc(100vh - 90px)", // full height - header
        overflow: "scroll",
    },
    listArea: {
        border: `1px solid ${theme.palette.grey["300"]}`,
        overflow: "hidden",
        borderRadius: 4,
        boxSizing: "border-box",
    },
    header: {
        width: "100%",
        height: 90,
        margin: 0,
        backgroundColor: theme.palette.background.paper,
        borderBottomStyle: "solid",
        borderBottomColor: theme.palette.grey["300"],
        borderBottomWidth: 1,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingLeft: 60,
        position: "sticky",
        top: 0,
        zIndex: 10,
    },
    heading: {
        flexGrow: 1,
        fontWeight: "bold",
    },
    empty: {
        width: "100%",
        padding: "50px",
        textAlign: "center",
    },
    emptyContent: {
        height: "calc(100vh - 90px)", // full height - header
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    emptyMessage: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    emptyIconContainer: {
        height: 56,
        width: 56,
        marginBottom: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        backgroundColor: theme.palette.common.white,
    },
    emptyIcon: {
        height: "40px !important",
        width: "40px !important",
        color: theme.palette.grey["300"],
    },
}));
